var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "overflow-auto h-100" }, [
    _vm.hasItems
      ? _c(
          "div",
          { staticClass: "item-list" },
          _vm._l(_vm.items, function (item) {
            return _c("list-item", {
              key: item.id,
              staticClass: "item-list__item",
              attrs: { row: item },
            })
          }),
          1
        )
      : _c(
          "div",
          {
            staticClass:
              "h-100 d-flex align-items-center justify-content-center text-muted-light font-weight-bold",
          },
          [_vm._v("\n    Empty\n  ")]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }